import { useRef, useState, useEffect } from "react";
import Icon from "../Icon/Icon";

export default function HorizontalScroller({ children, className = "" }) {
    const containerRef = useRef(null);
    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(false);

    const updateArrows = () => {
        const el = containerRef.current;
        if (!el) return;

        const atStart = el.scrollLeft <= 0;
        const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;

        setShowLeft(!atStart);
        setShowRight(!atEnd);
    };

    useEffect(() => {
        updateArrows();
        const el = containerRef.current;

        if (!el) return;
        el.addEventListener("scroll", updateArrows);

        return () => el.removeEventListener("scroll", updateArrows);
    }, []);

    const scrollByAmount = (amount) => {
        const el = containerRef.current;
        if (!el) return;
        el.scrollBy({ left: amount, behavior: "smooth" });
    };

    return (
        <div className={`relative ${className}`}>
            {/* Scroll container */}
            <div
                ref={containerRef}
                className="flex gap-2 overflow-x-auto whitespace-nowrap scrollbar-hide py-4"
            >
                {children}
            </div>

            {/* Left fade */}
            {showLeft && (
                <div className="pointer-events-none absolute top-0 left-0 w-12 h-full bg-gradient-to-r from-white to-transparent" />
            )}

            {/* Right fade */}
            {showRight && (
                <div className="pointer-events-none absolute top-0 right-0 w-12 h-full bg-gradient-to-l from-white to-transparent" />
            )}

            {/* Left arrow */}
            {showLeft && (
                <button
                    onClick={() => scrollByAmount(-200)}
                    className="absolute left-0 top-1/2 -translate-y-1/2 bg-white shadow rounded-full p-2 z-20"
                >
                    <Icon icon="chevronLeft" className="text-gray-600" />
                </button>
            )}

            {/* Right arrow */}
            {showRight && (
                <button
                    onClick={() => scrollByAmount(200)}
                    className="absolute right-0 top-1/2 -translate-y-1/2 bg-white shadow rounded-full p-2 z-20"
                >
                    <Icon icon="chevronRight" className="text-gray-600" />
                </button>
            )}
        </div>
    );
}
